import { api } from '../../client';

export interface TimeEntryDto {
  id: string;
  clocked_in_at: string;
  clocked_out_at: string | null;
  break_minutes?: number;
}

export const attendanceApi = {
  async today(): Promise<{ data?: TimeEntryDto[]; message?: string }> {
    return api.get('/hr/attendance/today') as Promise<{ data: TimeEntryDto[] }>;
  },

  async clockIn(): Promise<{ data?: TimeEntryDto; message?: string }> {
    return api.post('/hr/attendance/clock-in', {}) as Promise<{ data: TimeEntryDto; message?: string }>;
  },

  async clockOut(): Promise<{ data?: TimeEntryDto; message?: string }> {
    return api.post('/hr/attendance/clock-out', {}) as Promise<{ data: TimeEntryDto; message?: string }>;
  },

  async addBreakMinutes(
    minutes: number
  ): Promise<{ data?: TimeEntryDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/hr/attendance/add-break-minutes', { minutes }) as Promise<{
      data: TimeEntryDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },
};

export interface AttendanceRecordDto {
  id: string;
  employee_id: string;
  employee_name: string;
  date: string;
  time_in: string;
  time_out: string | null;
  break_minutes: number;
  total_hours: number | null;
  status: string;
}

export interface AttendanceSummaryDto {
  total_employees: number;
  present_today: number;
  absent_today: number;
  total_hours: number;
}

export const hrAttendanceMerchantApi = {
  async list(date: string): Promise<{
    data?: { summary: AttendanceSummaryDto; records: AttendanceRecordDto[] };
    message?: string;
  }> {
    const q = date ? `?date=${encodeURIComponent(date)}` : '';
    return api.get(`/hr/attendance${q}`) as Promise<{
      data: { summary: AttendanceSummaryDto; records: AttendanceRecordDto[] };
    }>;
  },

  async clockInForEmployee(employeeId: string): Promise<{
    data?: { id: string; employee_id: string; clocked_in_at: string; clocked_out_at: null };
    message?: string;
  }> {
    return api.post('/hr/attendance/clock-in-for-employee', { employee_id: employeeId }) as Promise<{
      data: { id: string; employee_id: string; clocked_in_at: string; clocked_out_at: null };
      message?: string;
    }>;
  },

  async addManual(data: {
    employee_id: string;
    date: string;
    time_in: string;
    time_out: string;
    break_minutes?: number;
  }): Promise<{ data?: AttendanceRecordDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/hr/attendance', data) as Promise<{
      data?: AttendanceRecordDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },
};
